// extracted by mini-css-extract-plugin
module.exports = {"mainMenu":"_3qoe2x3yLwycPK3ykybYkM","logo":"_2BWeC6a9W8Y2w8NTuqFk0q"};